module.exports = __webpack_public_path__ + "img/item2.3beb73ea.svg";